export function formatDate(input, locale = 'fr-FR') {
  if (!input) return '';
  const d = input instanceof Date ? input : new Date(input);
  return d.toLocaleDateString(locale, { year: 'numeric', month: 'short', day: '2-digit' });
}

export function formatDateTime(input, locale = 'fr-FR') {
  if (!input) return '';
  const d = input instanceof Date ? input : new Date(input);
  return d.toLocaleString(locale, { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export function formatCurrency(amount, currency = 'EUR', locale = 'fr-FR') {
  if (amount === null || amount === undefined || amount === '') return '';
  const code = typeof currency === 'string' && /^[A-Za-z]{3}$/.test(currency.trim())
    ? currency.trim().toUpperCase()
    : 'EUR';
  const n = typeof amount === 'number' ? amount : Number.parseFloat(String(amount).replace(',', '.'));
  if (Number.isNaN(n)) return `${amount} ${code}`;
  try {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: code }).format(n);
  } catch {
    return `${n} ${code}`;
  }
}

/** True if admin « Sur devis » OR prix catalogue vide / ≤ 0 (cas « X min · 0 € »). Prix > 0 → false. */
export function isCatalogOnQuote(service) {
  if (!service || typeof service !== 'object') return false;
  if (service.onQuote) return true;
  const raw = service.price;
  if (raw === null || raw === undefined || raw === '') return true;
  const n = typeof raw === 'number' ? raw : Number.parseFloat(String(raw).replace(',', '.'));
  if (Number.isNaN(n)) return false;
  return n <= 0;
}

/** Libellé vitrine / admin : « Sur devis » (si 0 € / onQuote) sinon montant. */
export function formatCatalogPrice(service) {
  if (isCatalogOnQuote(service)) return 'Sur devis';
  return formatCurrency(service?.price, service?.currency) || '—';
}

/** Meta carte : « Sur devis » seul si 0 € / onQuote ; sinon « N min · prix ». */
export function formatCatalogServiceMeta(service) {
  if (isCatalogOnQuote(service)) return 'Sur devis';
  const price = formatCatalogPrice(service);
  const mins = service?.durationMinutes;
  if (mins != null && Number(mins) > 0) {
    return `${mins} min · ${price}`;
  }
  return price || '—';
}

export function formatNumber(n, locale = 'fr-FR') {
  if (n === null || n === undefined) return '';
  return new Intl.NumberFormat(locale).format(n);
}
